import './index.css'

function TextHolder({heading,smallText}){
    return <div className="payment-desc-holder">
    <h2 className="big-text">{heading}</h2>
    <p className="small-text">{smallText}</p>
    </div>
}

export default TextHolder